import { render, staticRenderFns } from "./Sites.vue?vue&type=template&id=82a3641a&scoped=true&"
import script from "./Sites.vue?vue&type=script&lang=js&"
export * from "./Sites.vue?vue&type=script&lang=js&"
import style0 from "./Sites.vue?vue&type=style&index=0&id=82a3641a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82a3641a",
  null
  
)

export default component.exports